// TODO: Remove no-shadow eslint disable after fixed: https://github.com/typescript-eslint/typescript-eslint/issues/2484
// eslint-disable-next-line no-shadow
export enum EstimatedValuesMutationTypes {
    SET_ESTIMATED_VALUES = 'SET_ESTIMATED_VALUES',
  }
  